import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { shouldShowField, validateField } from '../../../../components/InputField/helper';
import { DialogContext } from '../../../../store/context/DialogContext';
import { useTranslation } from '../../../../store/context/TranslationContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import { IPLUS_WIZARD } from '../IPlushelper';
import { getVisibleWizardFieldOrder } from '../components/IndividualLite/helper';

const IPlusDigitalAssetsCustody = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    useEffect(() => {
        const initialErrors = {};
        iPlusFields.forEach((field) => {
            if (
                field.required &&
                field?.wizard === wizard &&
                shouldShowField(data, field.showIf)
            ) {
                const value = _.get(data, field.field);
                if (value === undefined || value === null || value === "") {
                    if (value !== false && !_.get(errors, field.field)) {
                        _.set(initialErrors, field.field, field.errorTypes?.required || field.error || "This field is required.");
                    }
                }
            }
        });

        const shownErrors = {};
        iPlusFields.forEach((field) => {
            if (field?.wizard === wizard && shouldShowField(data, field.showIf)) {
                const value = _.get(data, field.field);
                const error = validateField(field, value, data);
                if (error) {
                    _.set(shownErrors, field.field, error);
                }
            }
        });

        setErrors(_.merge({}, shownErrors, initialErrors));
    }, [data, wizard, iPlusFields]);

    const checkNext = () => {
        const orderedFields = getVisibleWizardFieldOrder({ fields: iPlusFields, wizard, data });
        for (const fieldPath of orderedFields) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: { wizard: IPLUS_WIZARD.Documents }, payload: data });
        } else {
            return;
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    }

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className='row pt-3'>
            <h2 className='fw-bold pt-0 mt-0 pb-2'>Cryptocurrency and Digital Assets Involvement</h2>
            <WrapperField
                disabled={asLabel}
                customProp={true}
                jsonField={cyclosFields["isActiveInvestor"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('isActiveInvestor', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["haveSelfCustodyWallet"]}
                dataObj={data}
                customProp={true}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('haveSelfCustodyWallet', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["walletAddress"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('walletAddress', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["centralisedExchanges"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('centralisedExchanges', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["centralisedExchangesOther"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('centralisedExchangesOther', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["receivingMakingBankingTransactionsCrypto"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('receivingMakingBankingTransactionsCrypto', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["receivingCryptocurrencyThirdParties"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('receivingCryptocurrencyThirdParties', errorMsg)}
                isForEDD={isForEDD}
            />

            <div className='mt-4'>
                <ButtonGroupNew
                    onNextClick={handleSubmit}
                    onBackClick={() => { handlePrev() }}
                    step={2}
                    hideSubmitButton={hideButtons}
                    showPageNum={false}
                    pageNum={2}
                    asLabel={false}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default IPlusDigitalAssetsCustody;
